import ReactPlayer from 'react-player';
import trainingVideo_LD from '@assets/video/training_vid_LD.mov';
import trainingVideo_Requester from '@assets/video/training_vid_Requester.mov';
import trainingVideo_Manager from '@assets/video/training_vid_Manager.mov';
import backgroundImg from '@assets/images/training_video_bg.png';
import trainingVideoImg from '@assets/images/training_video.png';
import { useState } from 'react';
import LocalStorage from '@utils/localStorage';

export default function TrainingVideo() {
  const user_details = LocalStorage.getItem('bbs_user');
  const [playing, setPlaying] = useState(false);

  const togglePlayPause = () => {
    setPlaying(!playing);
  };

  return (
    <div
      className={`flex flex-col gap-9 items-center justify-center mb-4 mt-12 mx-auto`}
    >
      <h1 className="text-2xl font-bold">Training Video</h1>
      <div className="relative">
        {!playing ? <img src={trainingVideoImg} alt="training img" /> : null}
        {playing ? (
          <ReactPlayer
            url={
              user_details?.user?.Role?.role === 'VIEWER'
                ? trainingVideo_LD
                : user_details?.user?.Role?.role === 'REQUESTER'
                  ? trainingVideo_Requester
                  : user_details?.user?.Role?.role === 'MANAGER'
                    ? trainingVideo_Manager
                    : null
            }
            playing={true}
            controls
            width="100%"
            height="60vh"
          />
        ) : (
          <div
            className=" absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer h-16 w-16 text-[3rem]"
            onClick={togglePlayPause}
          >
            {playing ? '' : '▶️'}
          </div>
        )}
      </div>
    </div>
  );
}
